export enum WorkerTopic {
  UpdateNode = 'UpdateNode'
}
